import { ICrudComponentPanel } from '../interfaces/ICrudComponentPanel';
import { ICrudEntity } from '../interfaces/ICrudEntity';
import { ICrudLoaded } from '../interfaces/ICrudLoaded';


export class CrudPanel<TDto extends ICrudEntity> implements ICrudComponentPanel {

  //#region Declarations...

  private _alreadyExpanded = false;

  //#endregion

  //#region Constructors...

  constructor(_description: string, _order: number) {
    this.description = _description;
    this.order = _order;
  }
  //#endregion


  //#region Properties...

  public error: boolean = false;

  // PRELOADUID
  public _preloadUid: string = '';
  get preloadUid() {
    return this._preloadUid;
  }
  set preloadUid(val) {
    this._preloadUid = val;

    // if (this._preloadUid == 'cancel')
    //  this.dataWrapper = null;

    this._alreadyExpanded = false;

    if (this.expanded) {
      this.uid = val;
      this._alreadyExpanded = true;
    } else {
      this.uid = '';
    }
  }

  // UID
  public uid: string = '';

  // EXPANDED
  private _expanded: boolean = false;
  get expanded() {
    return this._expanded;
  }
  set expanded(val) {
    this._expanded = val;

    if (!this._alreadyExpanded) {
      if (val && this.preloadUid != '') {
        this.uid = this.preloadUid;
        this._alreadyExpanded = true;
      }
    }
  }
  public order: number = 0;
  public description: string = '';

  // DATAWRAPPER
  public dataWrapper: TDto;
  
  //#endregion

}
